// extracted by css-extract-rspack-plugin
export default {"asterisk":"asterisk-IpLovN"};